import React from 'react';
import { FaLinkedin, FaBehance, FaYoutube, FaInstagram, FaFacebook } from 'react-icons/fa6';
import { Link } from 'react-router-dom';

const Footer1 = () => {
  const services = [
    {
      id: 'listing-optimization',
      title: 'Listing Optimization',
    },
    {
      id: 'ppc-management',
      title: 'Advertising',
    },
    {
      id: 'keyword-seo',
      title: 'Keywords – SEO',
    },
    {
      id: 'analytics',
      title: 'Graphics – Designs',
    },
    {
      id: 'product-research',
      title: 'Product Research',
    },
    {
      id: 'brand-registration',
      title: 'Brand Registration',
    },
    {
      id: 'catalogue-management',
      title: 'Catalogue Management',
    },
    {
      id: 'account-management',
      title: 'Account Management',
    },
    {
      id: 'troubleshooting',
      title: 'Trouble Shootings',
    },
  ];

  const socialLinks = [
    { Icon: FaLinkedin, url: 'https://www.linkedin.com/company/trioperspective' },
    { Icon: FaBehance, url: 'https://www.behance.net/trioperspective' },
    { Icon: FaYoutube, url: 'https://www.youtube.com/@trioperspective' },
    { Icon: FaInstagram, url: 'https://www.instagram.com/trioperspective/' },
    { Icon: FaFacebook, url: 'https://www.facebook.com/trioperspective' }
  ];

  return (
    <footer className="bg-white dark:bg-black text-gray-900 dark:text-white pt-24 pb-10 border-t border-gray-200 dark:border-gray-700">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-col items-center text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Ready to Scale Your Amazon Business?
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-400 max-w-2xl mb-8">
            Join Trioperspective and discover how we can boost your Amazon sales and optimize your seller performance
          </p>
        </div>

        {/* Amazon Partner Logo */}
        <a target="_blank" href="https://advertising.amazon.com/partners/directory/details/amzn1.ads1.ma1.2ruz3p5q26zhxc5curdraiziv/Trioperspective-LLC/" className="flex justify-center items-center gap-8 mb-4">
          <img 
            src="/images/amazon-ads-partner.png" 
            alt="Amazon Ads Partner" 
            className="h-32 object-contain"
          />
        </a>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          <div className="bg-gray-50/50 dark:bg-black/20 backdrop-blur-sm rounded-xl p-6 hover:bg-gray-100 dark:hover:bg-black/30 transition-colors">
            <h3 className="text-xl font-bold mb-6">Company</h3>
            <ul className="space-y-4">
              <li><a href="/about" className="text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors">About Us</a></li>
              <li><a href="/case-studies" className="text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors">Client Success Stories</a></li>
              <li><a href="/portfolio" className="text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors">Portfolio</a></li>
              <li><a href="/contact" className="text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors">Contact</a></li>
            </ul>
          </div>

          <div className="bg-gray-50/50 dark:bg-black/20 backdrop-blur-sm rounded-xl p-6 hover:bg-gray-100 dark:hover:bg-black/30 transition-colors">
            <h3 className="text-xl font-bold mb-6">Services</h3>
            <ul className="space-y-4">
            {services.map((service) => (
              <li><a href={`/services/${service.id}`} className="text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors">{service.title}</a></li>
            ))}
            </ul>
          </div>

          <div className="bg-gray-50/50 dark:bg-black/20 backdrop-blur-sm rounded-xl p-6 hover:bg-gray-100 dark:hover:bg-black/30 transition-colors">
            <h3 className="text-xl font-bold mb-6">Resources</h3>
            <ul className="space-y-4">
              <li><a href="/careers" className="text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors">Careers</a></li>
              <li><a href="/blog" className="text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors">Blog</a></li>
              <li><a href="/privacy-policy" className="text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors">Privacy Policy</a></li>
            </ul>
          </div>

          <div className="bg-gray-50/50 dark:bg-black/20 backdrop-blur-sm rounded-xl p-6 hover:bg-gray-100 dark:hover:bg-black/30 transition-colors">
            <h3 className="text-xl font-bold mb-6">Newsletter</h3>
            <p className="text-gray-600 dark:text-gray-400 mb-4">Subscribe to get latest Amazon selling tips and updates</p>
            <form className="space-y-4">
              <input
                type="email"
                placeholder="Enter your email"
                className="w-full px-4 py-3 bg-white dark:bg-black/30 rounded-lg focus:outline-none focus:ring-2 ring-1 focus:ring-primary ring-primary"
              />
              <button className="w-full px-4 py-3 bg-primary hover:bg-black dark:hover:bg-white hover:text-white dark:hover:text-black border border-primary rounded-lg font-medium transition-colors">
                Subscribe
              </button>
            </form>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-gray-200 dark:border-gray-800">
          <div className="grid grid-cols-5 gap-x-4 gap-y-4 mb-4 md:mb-0">
            {socialLinks.map(({ Icon, url }, index) => (
              <a 
                key={index} 
                href={url} 
                target="_blank"
                rel="noopener noreferrer"
                className="relative text-gray-600 dark:text-gray-400 bg-gray-50/50 dark:bg-black/20 backdrop-blur-sm rounded-lg p-4 hover:text-black dark:hover:text-black hover:bg-primary dark:hover:bg-primary transition-colors flex items-center justify-center overflow-hidden group"
              >
                <div className="absolute inset-0 bg-gradient-to-br from-primary/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                <Icon className="w-10 h-10 relative z-10" />
              </a>
            ))}
          </div>
          <a href="https://www.trustpilot.com/review/trioperspective.com" target="_blank" rel="noopener noreferrer">
            <img src="/images/Primary logo - tricolor black in white box RGB.png" alt="Trustpilot logo" className="w-48 h-auto mt-4 md:mt-0" />
          </a>
          <p className="text-gray-600 dark:text-gray-400 text-sm mt-4 md:mt-0">
            2025 Trioperspective. All rights reserved. | Amazon Seller Services Provider
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer1;
